//If you want to import everything from bootstrap uncomment this line and comment everything else below
//import {Tab, Modal, Collapse, Tooltip, Dropdown } from 'bootstrap';

// Import just what we need

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Tab from 'bootstrap/js/dist/tab';
import Modal from 'bootstrap/js/dist/modal';
window.Dropdown = Dropdown;
window.Tab = Tab;
window.Modal = Modal;
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js